import { PrintRow } from '~Components/PrinterManager';
import { i18nProps } from '~Translations';

/**
 * Builds the small "Your order number" slip that is handed to the customer so they
 * can pick up their order when it is called. Used by the self service kiosks (when
 * the customer declines a receipt) and by the POS when the
 * `printOrderSlip` setting is enabled.
 *
 * The slip is sent as its own print job, so the printer cuts the paper before it,
 * which gives a separate slip after the receipt.
 */
export const buildOrderNumberSlip = (orderNumber: string, i18n: i18nProps): PrintRow[] => {
  const paddedOrderNumber = orderNumber.padStart(3, '0');

  return [
    { content: ' ' },
    { content: ' ' },
    { content: ' ' },
    { content: ' ' },
    { content: ' ' },
    { content: `  ${i18n('SSK.YourOrderNumber')}  `, fontSize: 24 },
    { content: ` ${paddedOrderNumber} `, fontSize: 96 },
    { content: ' ' },
    { content: ' ' },
    { content: ' ' },
    { content: ' ' },
    { content: ' ' },
    { content: i18n('SSK.OrderNumber.PoweredBy'), fontSize: 12 },
  ];
};
